import { render, staticRenderFns } from "./Fssc22000BooleanField.vue?vue&type=template&id=0bd71544&scoped=true"
import script from "./Fssc22000BooleanField.vue?vue&type=script&lang=js"
export * from "./Fssc22000BooleanField.vue?vue&type=script&lang=js"
import style0 from "./Fssc22000BooleanField.vue?vue&type=style&index=0&id=0bd71544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd71544",
  null
  
)

export default component.exports